import { ISearchContext } from "../../global/models/search-context";
import { ISetContextAction, ActionType } from "../actions/index";

export function selectedSearchContext(state: ISearchContext, action: ISetContextAction) {
    if (typeof state === 'undefined') {
        state = null;
    }

    switch (action.type) {
        case ActionType.SET_CONTEXT:
            return action.context
        default:
            return state;
    }
}